<template>
  <a-modal title="Rollback" :visible="visible" width="500px" @cancel="cancel" :destroy-on-close="true">
    <a-input placeholder="Reason" v-model="reason" />

    <template slot="footer">
      <div class="flex justify-content-between">
        <a-button @click="cancel"> Cancel </a-button>
        <a-button type="primary" @click="submit" :loading="loading"> Rollback </a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import { Input, Modal, notification } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'

const { mapActions: pointSystemActions } = createNamespacedHelpers('pointSystem')

export default {
  components: {
    'a-modal': Modal,
    'a-input': Input
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      loading: false,

      reason: undefined
    }
  },
  methods: {
    ...pointSystemActions(['postRollback']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    cancel() {
      this.reason = undefined
      this.$emit('update:visible', false)
      this.$emit('update:id', undefined)
    },

    async submit() {
      this.loading = true

      try {
        const payload = {
          reason: this.reason,
          point_system_action_id: this.id
        }

        await this.postRollback(payload)

        this.$emit('rollback')
        this.cancel()
      } catch (error) {
        this.showNotification('error', 'Error', typeof error === 'string' ? error : error.message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
